module.exports = __webpack_public_path__ + "8862e498d4f2b5fa252be1309d6fa704.svg";